import { createAction, createReducer } from '@reduxjs/toolkit';

import { BackofficeRootState } from '../../store';

type UserState = {
  sso: {
    authStatus: 'UNKNOWN' | 'VERIFYING' | 'LOADED';
    error?: 'ERROR_LOADING_USER' | 'ACCOUNT_CREATED_BUT_DISABLED' | (string & {});
  };
};

const initialState: UserState = {
  sso: {
    authStatus: 'UNKNOWN',
  },
};

export const userSignedOut = createAction('[with auth] user signed out');
export const signInPageLoaded = createAction('[signin page] page loaded');
export const samlSSOInitiated = createAction('[signin page] clicked sign in with SSO');
export const errorOnLoadingSSOUser = createAction<{ error: string } | undefined>(
  '[sso page] errored on loading user from idp',
);

// Reducers
export const userReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(samlSSOInitiated, (state, { payload }) => {
      state.sso.error = undefined;
    })
    .addCase(signInPageLoaded, (state) => {
      if (window.location.search.length > 0) {
        state.sso.authStatus = 'VERIFYING';
      }
      const urlParams = new URLSearchParams(window.location.search);
      const errorFromSSOAuth = urlParams.get('error') as UserState['sso']['error'];

      if (errorFromSSOAuth) {
        state.sso.error = errorFromSSOAuth;
        state.sso.authStatus = 'LOADED';
      }
    })
    .addCase(errorOnLoadingSSOUser, (state, action) => {
      state.sso.error = action?.payload?.error ?? 'ERROR_LOADING_USER';
      state.sso.authStatus = 'LOADED';
    });
});

export const getUserSSOState = (state: BackofficeRootState) => state.me.sso;
